export enum DocumentMapsPrefixType {
    AUDIT_LOG = "AuditLog",
    ALL = "All",
  }